import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import FadeInComponent from "./FadeInComponent";
import SectionWrapper from "./SectionWrapper";
import React from "react";

export default function AboutSection() {
  const theme = useTheme();

  return (
    <SectionWrapper id="about-section">
      <Box sx={{ maxWidth: "100%", pt: 4 }}>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: { xs: "column", lg: "row" },
            gap: { xs: 4, lg: 12 },
            alignItems: "flex-start",
          }}
        >
          <Box
            sx={{
              flex: 1,
              maxWidth: { xs: "100%", lg: "35%" },
            }}
          >
            <FadeInComponent>
              <Typography
                variant="h4"
                sx={{
                  textAlign: "justify",
                  color: theme.palette.common.black,
                }}
              >
                Fondé en 2000, le Centre de recherche en rhumatologie GRMO
                réalise des études cliniques de phase 2, 3 et 4, visant à
                évaluer l'efficacité et la sécurité de nouveaux traitements et
                d'optimiser les thérapies existantes.
              </Typography>
            </FadeInComponent>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: { xs: 4, lg: 3 },
              flex: 1,
              maxWidth: { xs: "100%", lg: "60%" },
              minWidth: 0,
            }}
          >
            <FadeInComponent delay={0.1}>
              <Typography
                variant="body1"
                sx={{
                  color: theme.palette.grey[500],
                  textAlign: "justify",
                }}
              >
                Grâce à une cueillette rigoureuse des données, à un suivi
                personnalisé et à une équipe de recherche qualifiée, le GRMO
                offre un encadrement professionnel et humain. Les patients au
                centre bénéficient d'un accès à des médecins spécialistes en
                rhumatologie et en médecine interne, assurant une prise en
                charge complète et de qualité.
              </Typography>
            </FadeInComponent>

            <FadeInComponent delay={0.2}>
              <Typography
                variant="body1"
                sx={{
                  color: theme.palette.grey[500],
                  textAlign: "justify",
                }}
              >
                En participant à une étude clinique, les patients contribuent à
                faire avancer les connaissances et à améliorer les traitements
                en rhumatologie. Le GRMO a participé à l'évaluation de la
                majorité des traitements disponibles pour des maladies telles
                que l'arthrite et l'ostéoporose.
              </Typography>
            </FadeInComponent>

            <FadeInComponent delay={0.3}>
              <Typography
                variant="body1"
                sx={{
                  color: theme.palette.grey[500],
                  textAlign: "justify",
                }}
              >
                Le centre accueille principalement des patients de la région de
                Québec, et peut recevoir des participants de partout au Québec
                selon les besoins des études.
              </Typography>
            </FadeInComponent>
          </Box>
        </Box>
      </Box>
    </SectionWrapper>
  );
}
